module.exports = __webpack_public_path__ + "js/stellarium-web-engine.fa2c6454.wasm";